<template>
    <div style="display: flex;align-items: center;margin-bottom: 16px;">
        <div :style="{ width: labelWidth + 'px' }" style="font-size: 14px;color: #0E193B;">{{ title }}</div>

        <div :style="{ width: width + 'px',color: valueColor }"

            style=" background: #F4F8FF;border-radius: 2px;padding:5px;font-size: 14px;font-weight: bold;">
            {{ value }}</div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: ""
        },
        value: {
            type: String,
            default: ""
        },
        labelWidth: {
            type: Number,
            default: 100
        },

        width: {
            type: Number,
            default: 300
        },
        valueColor: {
            type: String,
            default: "#0F1A3A"
        }
    }
}
</script>